<template>
  <div id="entry">
    <common-header/>
    <div class="main">
      <section class="courseList">
        <div class="top"></div>
        <div class="content">
          <h2>{{ category }}机考模拟系统</h2>
          <div class="tip">
            <div class="tl"></div>
            <div class="tc">请您点击下列考试科目名称，进入机考模拟系统界面！推荐使用ie9以上浏览器</div>
            <div class="tr"></div>
          </div>
          <div class="list">
            <ul>
              <li v-for="(item,idx) in courseList" :key="idx" :title="item.siteCourseName">
                <a href="javascript:void(0)" target="_self" @click="toNext(item)">{{ item.siteCourseName }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="bottom"></div>
      </section>
    </div>
    <div class="footer"></div>
  </div>
</template>
<script>
  import { CommonHeader } from "@components/common"
  import mixin from "@/mixins/checkLogged"

  export default {
    name: "Entry",
    components: {
      CommonHeader
    },
    mixins: [mixin],
    data() {
      return {
        category: "",
        courseList: [],
        flag: ""
      }
    },
    mounted() {
      const { majorID, category } = this.$categoryInfo
      const { flag } = this.$route.params
      this.flag = flag === 'paidExam' ? '' : flag
      this.category = category
      this.$store.dispatch('getAllSiteInfo', { majorID: majorID, flag: this.flag }).then(res => {
        this.courseList = res
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    methods: {
      toNext(item) {
        const { flag } = this.$route.params
        this.$router.push({
          path: `/${flag}/mockExam`,
          query: {
            siteCourseID: item.siteCourseID,
            courseID: item.courseID
          }
        })
      }
    }
  }
</script>
